/**
 * 역할 전환 가능한 직업의 표시명을 원래 클래스명으로 변환
 * SVG 파일 경로와 매칭하기 위해 사용
 *
 * @param displayName - 화면에 표시되는 클래스 이름 (신의기사, 심판자 등)
 * @returns 원래 클래스 이름 (발키리, 홀리나이트)
 */
export function normalizeClassName(displayName: string): string {
  const classNameMap: Record<string, string> = {
    '신의기사': '발키리',
    '심판자': '홀리나이트',
  };

  return classNameMap[displayName] || displayName;
}
